"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apiAppender_1 = __importStar(require("./apiAppender"));
var consoleAppender_1 = __importDefault(require("./consoleAppender"));
exports.LOG_LEVELS = {
    error: 1,
    warn: 2,
    info: 3,
    debug: 4,
};
var _appenders;
var _maxLogLevel;
function initialize(isProduction, appName) {
    apiAppender_1.initialize(isProduction, appName);
    _appenders = !isProduction ? [consoleAppender_1.default, apiAppender_1.default] : [apiAppender_1.default];
    _maxLogLevel = !isProduction ? 'debug' : 'warn';
}
exports.initialize = initialize;
exports.default = (function (levelName, message, error, data) {
    try {
        if (exports.LOG_LEVELS[levelName] > exports.LOG_LEVELS[_maxLogLevel]) {
            return Promise.resolve();
        }
        return Promise.all(_appenders.map(function (append) { return append(levelName, message, error, data); }));
    }
    catch (err) {
        console.warn('failed to log', err.message);
        return;
    }
});
//# sourceMappingURL=index.js.map